/**
 * Combine tag-socket + backend health into final pill status.
 *
 * @typedef {'connected' | 'disconnected' | 'degraded'} ConnectionStatus
 * @typedef {'ok' | 'degraded' | 'down' | 'unknown'} BackendStatus
 *
 * Rules:
 *  - backend 'down' OR 'unknown' → 'disconnected'
 *  - backend 'degraded'          → 'degraded'
 *  - backend 'ok', socket up     → 'connected'
 *  - backend 'ok', socket down   → 'degraded'
 *
 * @param {{tagSocketConnected: boolean, backendStatus: BackendStatus}} inputs
 * @returns {ConnectionStatus}
 */
export function computeAggregateStatus({ tagSocketConnected, backendStatus }) {
  if (backendStatus === 'down' || backendStatus === 'unknown') {
    return 'disconnected';
  }
  if (backendStatus === 'degraded') {
    return 'degraded';
  }
  return tagSocketConnected ? 'connected' : 'degraded';
}
